import { render, staticRenderFns } from "./RecipesManagement.vue?vue&type=template&id=54bac9a4&scoped=true"
import script from "./RecipesManagement.vue?vue&type=script&lang=ts"
export * from "./RecipesManagement.vue?vue&type=script&lang=ts"
import style0 from "./RecipesManagement.vue?vue&type=style&index=0&id=54bac9a4&prod&lang=css"
import style1 from "./RecipesManagement.vue?vue&type=style&index=1&id=54bac9a4&prod&scoped=true&lang=css"
import style2 from "./RecipesManagement.vue?vue&type=style&index=2&id=54bac9a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bac9a4",
  null
  
)

export default component.exports